function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCrossShield = function SvgCrossShield(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "prefix__Group_896",
    width: 24,
    height: 24,
    "data-name": "Group 896",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_358",
    d: "M0 0h24v24H0z",
    "data-name": "Path 358",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_359",
    d: "M3.712 2.66L11.182 1l7.47 1.66a.909.909 0 0 1 .712.887v9.079a5.454 5.454 0 0 1-2.429 4.538L11.182 21l-5.753-3.835A5.455 5.455 0 0 1 3 12.627v-9.08a.909.909 0 0 1 .712-.887zm6.561 6.522H7.545V11h2.727v2.727h1.818V11h2.727V9.182h-2.726V6.455h-1.818z",
    "data-name": "Path 359",
    transform: "translate(1 1)",
    style: {
      fill: "currentColor"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCrossShield, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cross-shield.12d987e0.svg";
export { ForwardRef as ReactComponent };